/* evalLegends — the one-line icon glossaries the EvaluationStrip shows
 * for each visual. Icons mirror exactly what the graphs draw (journey
 * KIND_ICON / workflow KIND_ICON + edge flavors). */
import React from 'react';
import {
    AlertTriangle,
    Bot,
    ClipboardCheck,
    Flag,
    GitBranch,
    Map as MapIcon,
    Monitor,
    MoveRight,
    Play,
    Repeat,
    Route as RouteIcon,
    Undo2,
    Wand2,
    Workflow as WorkflowIcon,
    Zap
} from 'lucide-react';
import type {
    LegendItem
} from './EvaluationStrip';

export const JOURNEY_LEGEND: LegendItem[] = [
    {
        icon: <Monitor size={12} />,
        label: 'screen',
        meaning: 'surface with content the user sees'
    },
    {
        icon: <RouteIcon size={12} />,
        label: 'router',
        meaning: 'no content — exits route the run onward'
    },
    {
        icon: <ClipboardCheck size={12} />,
        label: 'task',
        meaning: 'waits on an assignee to act'
    },
    {
        icon: <Bot size={12} />,
        label: 'agent',
        meaning: 'an external agent session drives the surface'
    },
    {
        icon: <MapIcon size={12} />,
        label: 'journey',
        meaning: 'hands the run off to another journey'
    },
    {
        icon: <Flag size={12} />,
        label: 'END',
        meaning: 'the journey completes here'
    },
    {
        icon: <MoveRight size={12} />,
        label: 'edge',
        meaning: 'an exit — its label is the when condition'
    },
    {
        icon: <AlertTriangle size={12} />,
        label: 'badge',
        meaning: 'advisory on that surface (hover for details)'
    }
];

export const WORKFLOW_LEGEND: LegendItem[] = [
    {
        icon: <Play size={12} />,
        label: 'START',
        meaning: 'workflow name + declared inputs'
    },
    {
        icon: <Zap size={12} />,
        label: 'call',
        meaning: 'invokes a source capability'
    },
    {
        icon: <WorkflowIcon size={12} />,
        label: 'subflow',
        meaning: 'runs another workflow'
    },
    {
        icon: <Wand2 size={12} />,
        label: 'transform',
        meaning: 'shapes data, no side effects'
    },
    {
        icon: <GitBranch size={12} />,
        label: 'branch',
        meaning: 'forks into then/else lanes that rejoin'
    },
    {
        icon: <Repeat size={12} />,
        label: 'loop frame',
        meaning: 'repeats the framed steps per item'
    },
    {
        icon: <Undo2 size={12} />,
        label: 'compensation',
        meaning: 'dashed red — runs only on failure'
    },
    {
        icon: <Flag size={12} />,
        label: 'END',
        meaning: 'the declared output keys'
    },
    {
        icon: <AlertTriangle size={12} />,
        label: 'badge',
        meaning: 'advisory on that step (hover for details)'
    }
];
